export default [
    "videorandom",
    "bpalg",
    "pausealg",
    "msync",
    "warntraffic",
]